import { PropsWithChildren } from "react";

import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles({
    root: {
        "& > *": {
            marginBottom: "8px",
        },

        "& > *:last-child": {
            marginBottom: 0,
        },
    },
});

export const FormGroup = (props: PropsWithChildren<{}>) => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            {props.children}
        </div>
    );
};
